import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateServiceComponentFromComponent } from './update-service-component-from.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NbInputModule, NbSelectModule} from "@nebular/theme";

@NgModule({
  declarations: [UpdateServiceComponentFromComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NbInputModule,
    NbSelectModule,
  ],
  exports:[
    UpdateServiceComponentFromComponent,
  ]
})
export class UpdateServiceComponentFromModule { }
